module.exports = __webpack_public_path__ + "media/application/icon-arrow-down--blue-24a6299e.svg";